import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LeftCheckboxComponent} from './left-checkbox.component';
import {ToggleCheckboxModule} from '../../directives';


@NgModule({
  declarations: [LeftCheckboxComponent],
  imports: [
    CommonModule,
    ToggleCheckboxModule
  ],
  exports: [
    LeftCheckboxComponent
  ]
})
export class LeftCheckboxModule {
}
